import React, { useCallback, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import EventDispatcher from "../../../utils/event-dispatcher";
import { EventTypes } from "../../../utils/constants";
import { ConnectAccountsEvents } from "../../../utils/constants/events-types";
import ConnectAccountsStatus, {
  ConnectAccountsStatusType,
} from "../../../components/Payments/ConnectAccountsStatus/ConnectAccountsStatus";
import { handleConfirmConnectAccount } from "../../../api-clients/walletsBankAccountsClient";
import { PaymentProvider } from "@nestcoinco/hyper-api-gateway-api-client";

enum ConnectAccountsConfirmationUrlParams {
  CODE = "code",
}

const connectAccountsStatusMessage: Record<ConnectAccountsEvents, string> = {
  [EventTypes.CONNECT_ACCOUNTS.SUCCESSFUL]: "Account connected successfully",
  [EventTypes.CONNECT_ACCOUNTS.FAILED]: "Account connection failed",
  [EventTypes.CONNECT_ACCOUNTS.ERROR]: "Invalid URL!",
};

function ConnectAccountsConfirmation() {
  const { provider } = useParams();
  const [queryParams] = useSearchParams();
  const [connectAccountsStatus, setConnectAccountsStatus] =
    useState<ConnectAccountsEvents>();

  const confirmConnectAccount = useCallback(
    async (provider: PaymentProvider, token: string) => {
      const response = await handleConfirmConnectAccount({
        provider,
        resource: token,
      }).catch();

      if (response && response?.success) {
        const event = EventTypes.CONNECT_ACCOUNTS.SUCCESSFUL;
        setConnectAccountsStatus(event);
        EventDispatcher.dispatch(event, {
          message: connectAccountsStatusMessage[event],
        });
      } else {
        const event = EventTypes.CONNECT_ACCOUNTS.FAILED;
        setConnectAccountsStatus(event);
        EventDispatcher.dispatch(event, {
          message: connectAccountsStatusMessage[event],
        });
      }
    },
    []
  );

  useEffect(() => {
    const token = queryParams.get(ConnectAccountsConfirmationUrlParams.CODE);
    if (!provider || !token) {
      const event = EventTypes.CONNECT_ACCOUNTS.ERROR;
      setConnectAccountsStatus(event);
      EventDispatcher.dispatch(event, {
        message: connectAccountsStatusMessage[event],
      });
      return;
    }

    confirmConnectAccount(provider.toUpperCase() as PaymentProvider, token);
  }, [provider, queryParams, confirmConnectAccount]);

  return (
    <ConnectAccountsStatus
      eventType={connectAccountsStatus}
      type={
        connectAccountsStatus
          ? ConnectAccountsStatusType.DONE
          : ConnectAccountsStatusType.LOADING
      }
      title={
        connectAccountsStatus
          ? connectAccountsStatusMessage[connectAccountsStatus]
          : "Connecting account"
      }
      message={connectAccountsStatus ? "" : "We're finalizing the process..."}
    />
  );
}

export default ConnectAccountsConfirmation;
